import { render, staticRenderFns } from "./BuildPooledStatements.vue?vue&type=template&id=bea48fda&scoped=true"
import script from "./BuildPooledStatements.vue?vue&type=script&lang=js"
export * from "./BuildPooledStatements.vue?vue&type=script&lang=js"
import style0 from "./BuildPooledStatements.vue?vue&type=style&index=0&id=bea48fda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea48fda",
  null
  
)

export default component.exports